import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Pagination } from '../../../models/pagination';
import { TipoActivoFijo } from '../../../models/tipo-activo-fijo';
import { TipoActivoFijoService } from '../../../services/tipo-activo-fijo.service';

@Component({
  selector: 'app-tipo-activo-fijo-modal',
  templateUrl: './tipo-activo-fijo-modal.component.html',
  styleUrls: ['./tipo-activo-fijo-modal.component.css'],
  providers:[
    TipoActivoFijoService
  ]
})
export class TipoActivoFijoModalComponent implements OnInit {
  @Output() sendTipo = new EventEmitter();

  public loading:boolean;
  public tipos : Array<any>;
  public busqueda: string;
  public selectedRow: Number;
  public pagination: Pagination;
  public tipo_activo:TipoActivoFijo;
  constructor(
    private tipoActivoFijoService:TipoActivoFijoService,
    public bsModalRef: BsModalRef,

  ) {
    this.loading= false;
    this.tipos = [];
    this.busqueda ="";
    this.pagination = new Pagination();
    this.tipo_activo = new TipoActivoFijo(); 
  }

  ngOnInit() {
    let qs = "";
    let p1 = this.getTipos(qs);
    this.loading = true;
    Promise.all([p1]).then(
      res=> this.loading = false,
      err => this.loading = false
    )
  }
  getQs(){
		return "&q[nombre]=" + this.busqueda;
	}
  getTipos(qs){
    return new Promise((resolve,reject)=>{
      this.tipoActivoFijoService.getAll("?page=" + this.pagination.current_page + "&per_page=20&sort=-id"+qs).subscribe(
        res=>{
          this.tipos = res.data
          this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        },err=>{
          reject(err);
        }
      );
    });
  }

  onSelectRow(tipo, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.tipo_activo = tipo;
	}

	onDBLClick(usuario, i) {
		this.onSelectRow(usuario, i);
		this.onSubmit();
  }

  onSearch(event) {
    this.busqueda = event;
    let qs = "";
    if (this.busqueda != "") {
       qs = this.getQs();
    }
    this.loading = true;
    let id = "";
		this.getTipos(qs).then(
			res => this.loading = false,
			err => this.loading = false
		);

	}
  
  onSubmit() {
		//si existe lote seleccionado
		if (this.tipo_activo) {
			//envía de objecto usuario
			this.sendTipo.emit(this.tipo_activo);
			this.bsModalRef.hide();
		} else {
			//Cierre de modal o componente
			this.bsModalRef.hide();
		}
  }
  
  next() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
		this.pagination.current_page++;
		this.getTipos(qs);
	}

	prev() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
		this.pagination.current_page--;
		this.getTipos(qs);
	}

	first() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
		this.pagination.current_page = 1;
		this.getTipos(qs);
	}

	last() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
		this.pagination.current_page = this.pagination.last_page;
		this.getTipos(qs);
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/tipo-activo-fijo-modal/tipo-activo-fijo-modal.component.ts